import { Form } from '@unistocks/components/form/form';
import { SharedPortfolioSettings } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { FormProps } from '@unistocks/types/form-props';
import { z } from 'zod';

export type SharedPortfolioSettingsFormProps = FormProps<SharedPortfolioSettings>;

const schemaFactory = () =>
  z.object({
    includeHistory: z.boolean(),
    includeNominalValues: z.boolean()
  });

export const SharedPortfolioSettingsForm: React.FC<SharedPortfolioSettingsFormProps> = ({
  initialValues,
  isSubmitting,
  onSubmit
}) => {
  const schema = schemaFactory();

  return (
    <Form
      schema={schema}
      initialValues={initialValues}
      isLoading={isSubmitting}
      customTrigger={null}
      onSubmit={onSubmit}
    >
      {({ formState: { isSubmitting } }, submit) => (
        <Form.Section
          label={t('::Settings')}
          helpText={`${t('::Portfolio:Share:IncludeHistory')}:\n${t('::Portfolio:Share:IncludeHistory:HelpText')}\n\n${t('::Portfolio:Share:IncludeNominalValues')}:\n${t('::Portfolio:Share:IncludeNominalValues:HelpText')}`}
        >
          <Form.Checkbox
            name="includeHistory"
            label={t('::Portfolio:Share:IncludeHistory')}
            helpText={t('::Portfolio:Share:IncludeHistory:HelpText')}
            isDisabled={isSubmitting}
            onCheckedChange={() => submit()}
          />
          {/* <Form.Checkbox
            name="includeNominalValues"
            label={t('::Portfolio:Share:IncludeNominalValues')}
            helpText={t('::Portfolio:Share:IncludeNominalValues:HelpText')}
            isDisabled={isSubmitting}
            onCheckedChange={() => submit()}
          /> */}
        </Form.Section>
      )}
    </Form>
  );
};

SharedPortfolioSettingsForm.displayName = 'SharedPortfolioSettingsForm';
